import React, { useEffect, useState } from 'react';
import { Button, Form, Spin } from 'antd';
import { RcFile } from 'antd/lib/upload/interface';

import { identity, isEitherAdmin, isVentureBuilder } from 'utils';
import { SPPartnerUserProps } from 'types/user';
import {
  Breadcrumb,
  EditProfileImage,
  FormBuilder,
  Input,
  TitleWithActions,
} from 'components/components';
import routes from 'routes';
import { scrollToFirstError } from 'components/components/FormBuilder/utils/helpers';
import { PartnerMemberType, SPMemberType } from 'packages/user_repository';
import MyProfileChangePassword from 'components/MyProfileChangePassword';
import { editAdminFields, editPartnerMemberFormFields } from '../../utils/formFields';

const EditPartnerSPMember = (props: SPPartnerUserProps) => {
  const { firstName, lastName, id } = props.user;
  const isProfileUnavailable = isVentureBuilder(props.userType) && !identity.isPositiveNumber(id);
  const fields = isEitherAdmin(props.userType) || isVentureBuilder(props.userType)
    ? editAdminFields : editPartnerMemberFormFields;
  const [photo, setPhoto] = useState('');

  useEffect(() => {
    if (!identity.isPositiveNumber(id)) {
      props.actions.getMyProfileData();
    }
  }, [id]);

  const [form] = Form.useForm();

  useEffect(() => {
    setPhoto(props.user.photo as string);
  }, [props.user]);

  useEffect(() => {
    if (isProfileUnavailable) return;

    form.setFieldsValue(props.user);
    form.setFieldValue('photo', props.user.photo);
  }, [form, props.user, isProfileUnavailable]);

  const handleSubmit = (data: PartnerMemberType | SPMemberType) => {
    props.actions.editMyProfileData({ data: { ...data, photo: form.getFieldValue('photo') } });
  }

  const handleBeforeUpload = (file: RcFile) => {
    form.setFieldValue('photo', file as Blob);
    return false;
  }

  if (isProfileUnavailable) {
    return (
      <Spin spinning={props.isLoading}>
        <div className="edit-my-profile">
          <Breadcrumb navigateTo={routes.myProfileUrl} routeName="My profile" />
          <TitleWithActions title="Edit profile" />
          {!props.isLoading && (
            <Button onClick={() => props.actions.getMyProfileData()}>Reload profile</Button>
          )}
        </div>
      </Spin>
    );
  }

  return (
    <Spin spinning={props.isLoading}>
      <div className="edit-my-profile">
        <Breadcrumb navigateTo={routes.myProfileUrl} routeName="My profile" />
        <TitleWithActions title={`${firstName} ${lastName}`} />
        <Form
          onFinish={handleSubmit}
          onFinishFailed={scrollToFirstError}
          validateTrigger={[]}
          form={form}
        >
          <div className="edit-my-profile__fields">
            <EditProfileImage imageLink={photo} beforeLogoUpload={handleBeforeUpload} />
            <FormBuilder
              oneColumn
              layout="horizontal"
              fields={fields}
              formFragment
            />
            <Button htmlType="submit" className="primary-button" loading={props.isLoading}>save</Button>
          </div>
        </Form>
        <Input.Heading title="Change Password" />
        <MyProfileChangePassword />
      </div>
    </Spin>
  );
}

export default EditPartnerSPMember;
